import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Center, Button, Box, Image, Stack, Text } from "@chakra-ui/react"
import { UserContext } from "../Contexts/UserContext"
import { Partners } from "../partnershipData"

export const AdminJobRequestView = ({ nextStep }) => {
	const { userPlus } = useContext(UserContext)
	const navigate = useNavigate()
	const partner = Partners.find((p) => p.id === userPlus?.partner)
	const [selectedType, setSelectedType] = useState(null) // Track selected type

	const handleNext = () => {
		if (selectedType === "single") {
			nextStep()
		} else if (selectedType === "bulk") {
			navigate("/job-requests/bulk-upload")
		}
	}

	return (
		<Center
			flexDirection="column"
			maxW="629px"
			margin={{ base: "15px", md: "auto" }}
			gap={3}
		>
			<Stack>
				<Text mb="20px">
					To get started, select the type of work order you’d like to submit.
				</Text>
				<Box
					as="button"
					onClick={() => setSelectedType("single")}
					cursor="pointer"
					_hover={{ transform: "scale(1.05)" }}
					transition="transform 0.2s"
					border={selectedType === "single" ? "2px solid" : "none"}
					borderColor={
						selectedType === "single" ? "borderColor" : "transparent"
					}
					borderRadius="md"
					p="10px"
				>
					<Image
						src={
							partner
								? `/assets/${partner.id}_house_landscape.svg`
								: "/assets/house_landscape.png"
						}
						alt="Single Upload"
						boxSize="150px"
						mx="auto"
					/>
					<Text mt="10px">A work order for a single service and address</Text>
				</Box>
				<Box
					as="button"
					onClick={() => setSelectedType("bulk")}
					cursor="pointer"
					_hover={{ transform: "scale(1.05)" }}
					transition="transform 0.2s"
					border={selectedType === "bulk" ? "2px solid" : "none"}
					borderColor={selectedType === "bulk" ? "borderColor" : "transparent"}
					borderRadius="md"
					p="10px"
				>
					<Image
						src={
							partner
								? `/assets/${partner.id}_bulk_upload.svg`
								: "/assets/bulk_upload.svg"
						}
						alt="Bulk Upload"
						boxSize="150px"
						mx="auto"
					/>
					<Text mt="10px">Add multiple work orders for multiple addresses</Text>
				</Box>
				<Button
					onClick={() => handleNext()}
					bgColor="borderColor"
					color="white"
					w="100%"
					mt="10px"
					mb="40px"
					isDisabled={!selectedType} // Disable button if no type is selected
				>
					Continue
				</Button>
			</Stack>
		</Center>
	)
}
